import React from "react";
import "../../styles/components/RelatioHero.css";

import relatioPhone from "../../img/cases/relatio-phone-2.webp";
import cloudsImage from "../../img/cases/case-clouds-2.webp";
import relatioLogo from "../../img/cases/relatio-logo.png";

export default function RelatioHero() {
  return (
    <section className="relatio-hero relatio-hero--relatio relatio-hero-anim">
      <div className="relatio-hero__content relatio-hero-anim__content">
        <h1 className="relatio-hero__title">
          AI-Powered <strong>Relationship Coaching</strong>
          <br />
          with <strong>Deep Personalization</strong>
        </h1>

        <p className="relatio-hero__text">
          A conversational AI mentor that maintains a structured memory of each
          user — their progress, emotional state, and history — to deliver
          coaching that evolves with every interaction.
        </p>

        <div className="relatio-hero__chips">
          <span>NestJS</span>
          <span>Prisma</span>
          <span>PostgreSQL</span>
          <span>Qdrant</span>
          <span>Redis</span>
          <span>Google Gemini</span>
        </div>
      </div>

      <div className="relatio-hero__glass relatio-hero__glass--client relatio-hero-anim__glass-1">
        <span>Client</span>
        <img
          className="relatio-hero__logo relatio-hero__logo--relatio"
          src={relatioLogo}
          alt="Relatio"
        />
      </div>

      <div className="relatio-hero__glass relatio-hero__glass--industry relatio-hero-anim__glass-2">
        <span>Industry</span>
        <strong>RELATIONSHIP</strong>
      </div>

      <img
        className="relatio-hero__clouds relatio-hero-anim__clouds"
        src={cloudsImage}
        alt=""
        aria-hidden="true"
      />

      <img
        className="relatio-hero__phone relatio-hero__phone--relatio relatio-hero-anim__phone"
        src={relatioPhone}
        alt="Relatio app"
      />
    </section>
  );
}
